import { render, staticRenderFns } from "./ShiftAttendanceComparison.vue?vue&type=template&id=3710e163&scoped=true"
import script from "./ShiftAttendanceComparison.vue?vue&type=script&lang=js"
export * from "./ShiftAttendanceComparison.vue?vue&type=script&lang=js"
import style0 from "./ShiftAttendanceComparison.vue?vue&type=style&index=0&id=3710e163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710e163",
  null
  
)

export default component.exports